import request from '@/utils/request'

export default {
  // 获取资源列表
  getList(params) {
    return request({
      url: '/console/resources',
      method: 'get',
      params
    })
  },
  // 编辑资源
  editResource(id, params) {
    return request({
      url: `/console/resources/${id}`,
      method: 'put',
      data: params
    })
  },
  // 添加资源
  addResource(params) {
    return request({
      url: `/console/resources`,
      method: 'POST',
      data: params
    })
  },
  // 获取资源详情
  getResourceDetail(id) {
    return request({
      url: `/console/resources/${id}`,
      method: 'get'
    })
  },
  // 授权
  authorize(id, params) {
    return request({
      url: `/console/resources/${id}/authorize`,
      method: 'POST',
      data: params
    })
  }
}
